import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Emoji } from 'emoji-mart';
import Chip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Chip';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { noop } from 'Helpers/PropTypes';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Tooltip';
import makeStyles from '@material-ui/core/styles/makeStyles';

const EMOJI_SIZE = 18;

const useStylesTooltip = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
    maxWidth: 220,
    borderRadius: 6,
  },
}));

const styles = ((theme) => ({
  root: {},
  emoji: {
    display: 'flex',
    height: EMOJI_SIZE,
  },
  count: {
    alignSelf: 'center',
    marginLeft: theme.spacing(0.5),
  },
}));

const Reaction = ({
  className,
  classes,
  emoji,
  tooltip,
  count,
  isMyEmoji,
  handleAdd,
  handleRemove,
  ...rest
}) => {
  const tooltipClasses = useStylesTooltip();
  return (
    <Tooltip
      classes={tooltipClasses}
      title={tooltip || emoji}
      enterDelay={500}
      placement="top"
      arrow
    >
      <Chip
        className={classNames(classes.root, className)}
        variant="outlined"
        color={isMyEmoji ? 'primary' : 'default'}
        size="small"
        label={
          <span className={classes.emoji}>
            <Emoji emoji={emoji} size={EMOJI_SIZE} />
            <Typography color={isMyEmoji ? 'primary' : 'primaryGray'} className={classes.count}>{count.toString()}</Typography>
          </span>
        }
        onClick={isMyEmoji ? handleRemove : handleAdd}
        {...rest}
      />
    </Tooltip>
  );
};

Reaction.defaultProps = {
  className: '',
  isMyEmoji: false,
  handleAdd: noop,
  handleRemove: noop,
  tooltip: '',
};

Reaction.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  emoji: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  count: PropTypes.number.isRequired,
  isMyEmoji: PropTypes.bool,
  handleAdd: PropTypes.func,
  handleRemove: PropTypes.func,
};


export default withStyles(styles)(Reaction);
